import { IdentificationType } from "./identification-type";

/**
 * Model for document upload component.
 */
export class OnboardingDocumentUpload {
  identificationType: IdentificationType;
  documents: OnboardingDocument[];

  constructor() {
    this.identificationType = new IdentificationType();
    this.documents = [];
  }
}

export enum DocumentUploadType {
  Unknown,
  Passport,
  CardFront,
  CardBack
}

export enum UploadIdentificationType {
  Unknown,
  DL,
  IdCard,
  ResidentCard,
  Passport
}

export class OnboardingDocument {
  type: DocumentUploadType | null;
  uploadedFile: File | null;

  constructor() {
    this.type = DocumentUploadType.Unknown;
    this.uploadedFile = null;
  }

  typeString = () => {
    switch(this.type) {
      case DocumentUploadType.Passport: return "Passport Image";
      case DocumentUploadType.CardFront: return "Front Image";
      case DocumentUploadType.CardBack: return "Back Image";
      default: return "Unknown";
    }
  }
}
